'use client';

import { useDeferredValue } from 'react';

import { ToastsProvider } from '@/utils/hooks/context/toast/useToastsContext';
import { useFeatureFlag } from '@/utils/hooks/featureFlag/useFeatureFlag';
import useCurrentSession from '@/utils/hooks/user/useCurrentSession';

import { DatepickerGlobalStoreProvider } from '@/utils/zustand/providers/datepicker-global-provider';

import LoaderPage from '@/components/base/Loader/LoaderPage';
import { SparksAgent } from '@/components/composite/SparksAgent';

export function GlobalWrapper({ children }: { children: React.ReactNode }) {
    const { isLoading } = useCurrentSession();
    const isAiAgentActive = useFeatureFlag('ai_agent_active');
    const deferredIsLoading = useDeferredValue(isLoading);

    if (deferredIsLoading) {
        return <LoaderPage />;
    }

    return (
        <DatepickerGlobalStoreProvider>
            <ToastsProvider>
                <div className="flex h-full w-full">
                    {children}
                    {isAiAgentActive && <SparksAgent />}
                </div>
            </ToastsProvider>
        </DatepickerGlobalStoreProvider>
    );
}
